import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import CampaignService from '@forwardflow/services/CampaignService'
import useSWR from 'swr'

export const useGetActiveLeadSource = (title: string) => {
   const { data, error, isValidating, isLoading, mutate } = useSWR(
      title ? [QUERY_KEYS.GET_LEAD_SOURCES, title] : null,
      () => CampaignService.getActiveLeadSources(title)
   )

   return {
      data,
      isLoading: isLoading || (!data && isValidating),
      isValidating,
      error,
      mutate,
   }
}
